import {
  link_default
} from "./chunk-JSVC6WBO.js";

// src/blocks/link/index.ts
var link_default2 = link_default;

export {
  link_default2 as link_default
};
